import { render } from "./Stream.vue?vue&type=template&id=7622e1a0&scoped=true&bindings={\"streamId\":\"props\",\"config\":\"setup\",\"stream\":\"setup\",\"channel\":\"setup\",\"prettyViewers\":\"setup\",\"viewersDiff\":\"setup\",\"prettyViewersDiff\":\"setup\",\"prettyDuration\":\"setup\",\"previewsTimer\":\"setup\"}"
import script from "./Stream.vue?vue&type=script&lang=js"
export * from "./Stream.vue?vue&type=script&lang=js"

import "./Stream.vue?vue&type=style&index=0&id=7622e1a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7622e1a0"

export default script